import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, assetUrl } from "@/lib/api";
import { BeforeAfter } from "@/components/BeforeAfter";


export const HeroProject = () => {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/explore").then(({ data }) => setV(data[0] || null)).catch(() => {}); }, []);
  if (!v) return <div className="aspect-[4/3] w-full rounded-[12px] bg-[var(--bone-2)]" data-testid="hero-project-loading" />;
  const p = v.project;
  return (
    <div data-testid="hero-project">
      <div className="overflow-hidden rounded-[12px]">
        <BeforeAfter before={assetUrl(v.beforeUrl)} after={assetUrl(v.afterUrl)} width={v.width} height={v.height} testid="hero-before-after" beforeLabel="Before" afterLabel="Vision" />
      </div>
      {v.provenanceLine && <p className="mt-2 text-[0.68rem] text-[var(--stone-dark)]" data-testid="hero-provenance">{v.provenanceLine}</p>}
      {p && (
        <Link to={`/v/${v.id}`} className="card mt-3 block p-4 transition-transform hover:-translate-y-0.5" data-testid="hero-project-card">
          <div className="eyebrow">{v.propertyTitle}</div>
          <div className="mt-1 font-display text-xl">{v.directionName}</div>
          <dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
            <dt className="text-[var(--stone-dark)]">Budget</dt><dd className="text-right font-mono-ui" data-testid="hero-project-budget">{p.budget}</dd>
            <dt className="text-[var(--stone-dark)]">Contributors</dt><dd className="text-right font-mono-ui" data-testid="hero-project-contributors">{p.supporters}</dd>
            <dt className="text-[var(--stone-dark)]">Owner</dt><dd className="text-right" data-testid="hero-project-owner">{p.ownerStatus}</dd>
          </dl>
          <p className="mt-3 text-sm" data-testid="hero-support-line">{p.supportLabel}</p>
          <p className="mt-1 text-sm" data-testid="hero-funds-line">{p.fundsLabel}{p.testFundsLabel ? ` · ${p.testFundsLabel}` : ""}</p>
          <div className="mt-3 text-sm font-semibold text-[var(--green)]">View project →</div>
        </Link>
      )}
    </div>
  );
};
